import { MemoryLocationConfig, MemoryLocationService } from '@uirouter/core';
export function editorLocationPlugin(flowApi) {
  return function (router) {
    const configuration = new MemoryLocationConfig();
    const service = new MemoryLocationService(router);
    router.locationConfig = configuration;
    router.locationService = service;
    return {
      name: 'WixUIRouterEditorLocation',
      dispose(router) {
        router.dispose(configuration);
        router.dispose(service);
      }
    };
  };
}
//# sourceMappingURL=plugin.js.map